export const INPUT_DELAY = Number(process.env.REACT_APP_INPUT_DELAY) || 500
